<template>
  <el-dialog
    center
    id="confirm-dialog"
    class="fs-dialog-confirm"
    :title="title"
    :visible.sync="open"
    :show-close="false"
    :modal="false"
    :close-on-click-modal="false"
  >
    <el-row>
      <el-col class="fs-desc text-left pt--1">
         <label class="text-heading3" style="color: #262628;">{{ desc }}</label>
      </el-col>
      <el-col class="text-center">
        <el-row v-if="dialogDisplayBtn == 'both'">
          <el-col :span="12">
            <el-button class="cancel text-button" @click="resetDialogConfirm">{{ $t('dialog.no') }}</el-button>
          </el-col>
          <el-col :span="12">
            <el-button v-bind:class="dialogClassBtn2" class="text-button" type="primary" @click="confirmAction">{{ $t('dialog.yes') }}</el-button>
          </el-col>
        </el-row>
        <el-row v-else>
          <el-col>
            <el-button v-bind:class="dialogClassBtn2" class="text-button" type="primary" @click="confirmAction">{{ $t('dialog.ok') }}</el-button>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
  export default {
    name: 'DialogConfirm',
    data () {
      return {
        open: false,
        title: '',
        desc: ''
      }
    },
    mounted () {
      this.$store.commit('setConfirmDialog', [false])
      this.$store.commit('setDialogUserConfirm', false)
    },
    methods: {
      confirmAction () {
        this.$store.commit('setConfirmDialog', [false])
        this.$store.commit('setDialogUserConfirm', true)
      },
      resetDialogConfirm () {
        this.open = false
        this.$store.commit('setConfirmDialog', [false])
        this.$store.commit('setDialogUserConfirm', false)
      }
    },
    computed: {
      dialogDisplay () {
        this.open = this.$store.getters.dialogDisplay
        return this.$store.getters.dialogDisplay
      },
      dialogHeaderText () {
        this.title = this.$store.getters.dialogHeaderText
        return this.$store.getters.dialogHeaderText
      },
      dialogContentText () {
        this.desc = this.$store.getters.dialogContentText
        return this.$store.getters.dialogContentText
      },
      dialogClassBtn2 () {
        return this.$store.getters.dialogClassBtn2
      },
      dialogDisplayBtn () {
        return this.$store.getters.dialogDisplayBtn
      }
    },
    watch: {
      dialogDisplay (value) {
        this.open = value
      },
      dialogHeaderText (value) {
        this.title = value
      },
      dialogContentText (value) {
        this.desc = value
      },
      open (value) {
        if (!value) {
          this.$store.commit('setConfirmDialog', [false])
          this.$store.commit('setDialogUserConfirm', false)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
#confirm-dialog {
  /deep/ {
    .el-dialog__header {
      text-align: start;
    }
    
    .el-dialog__title {
      font-size: 30px;
      font-weight: 700;
      color: #262628;
    }
  } 
}
</style>


// WEBPACK FOOTER //
// src/components/dialog/DialogConfirm.vue